var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCertificateInvalid = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 33"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M23.65 8.38a1.21 1.21 0 0 0-1.711 0l-5.934 5.922-5.934-5.934A1.21 1.21 0 1 0 8.36 10.08l5.934 5.934-5.934 5.935a1.208 1.208 0 0 0 0 1.71 1.208 1.208 0 0 0 1.71 0l5.935-5.933 5.934 5.934a1.208 1.208 0 0 0 1.711 0 1.209 1.209 0 0 0 0-1.711l-5.934-5.934 5.934-5.934a1.216 1.216 0 0 0 0-1.7Z"
})));
export default SvgCertificateInvalid;